export const PAID_COEFFICIENT_COLOR = '#FEE0E0';
export const PAID_COEFFICIENT_BACKGROUND_COLOR = '#F96666';
export const FREE_COEFFICIENT_COLOR = '#DEF1DD';
export const FREE_COEFFICIENT_BACKGROUND_COLOR = '#067B00';
export const STANDART_PAID_ACCEPTANCE = 1;
/** Лимит исчерпан */
export const UNLIMITED_COEFFICIENT = -1;
/**  Данные константы добавлены сюда, т.к. есть вероястность, что их нужно будет быстро поменять, не затрагивая переводы */
export const RUB_FOR_LITER = 15;
export const LITERS_FOR_RUB = 5;
export const NEXT_LITER = '1,5';
